import styled from "styled-components";
import {Col, Row} from "antd";

export const RestorePage = styled(Row)`
  height: 100%;
`

export const LeftCol = styled(Col)`
  padding: 64px;
`

export const RightCol = styled(Col)`
  background-color: #B5B1FF;
  padding: 80px;
  position: relative;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  
  .image{
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
  }
`